import { Link, useOutletContext } from "react-router-dom";
import useDeviceList from "../hooks/useDeviceList";
import { consoleFeatures } from "../config/consoleFeatures";

export default function Dashboard() {
  const { profile } = useOutletContext();
  const { devices, loading, error } = useDeviceList();

  if (loading) return <div className="spinner" />;

  return (
    <div>
      <h2 className="page-title">
        Welcome{profile?.full_name ? `, ${profile.full_name}` : ""}
      </h2>
      <p className="page-sub">Overview of your XM Edge environment</p>

      {error && <div className="alert alert-error">{error}</div>}

      <div className="grid-2">
        <div className="card">
          <h2>Devices</h2>
          <p className="desc">Devices visible to your account</p>
          <div style={{ fontSize: 36, fontWeight: 800 }}>{devices.length}</div>
          <Link to="/devices" className="btn btn-outline btn-sm" style={{ marginTop: 12 }}>
            View devices
          </Link>
        </div>

        <div className="card">
          <h2>Your role</h2>
          <p className="desc">Determines what you can manage</p>
          <span className={`badge ${profile?.role === "admin" ? "badge-blue" : "badge-gray"}`} style={{ fontSize: 15, padding: "6px 16px" }}>
            {profile?.role || "—"}
          </span>
          <div style={{ marginTop: 12 }}>
            <Link to="/account" className="btn btn-outline btn-sm">
              Manage account
            </Link>
          </div>
        </div>
      </div>

      <div className="card">
        <h2>Recent devices</h2>
        <p className="desc">The most recently added devices you can access</p>
        {devices.length === 0 ? (
          <div className="empty">No devices attached to your account yet.</div>
        ) : (
          <div className="table-wrap">
            <table className="tbl">
              <thead>
                <tr>
                  <th>BEID</th>
                  {consoleFeatures.showDeviceName && <th>Name</th>}
                  <th>State</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {devices.slice(0, 5).map((d) => (
                  <tr key={d.id}>
                    <td className="mono">{d.beid}</td>
                    {consoleFeatures.showDeviceName && <td>{d.name || <span className="muted">—</span>}</td>}
                    <td>{d.enrollment_state}</td>
                    <td style={{ textAlign: "right" }}>
                      <Link to={`/devices/${d.id}`} className="btn btn-outline btn-sm">
                        Details
                      </Link>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}
